import * as React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
// import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme: any) => ({
  buttonColor: {
    color: "#1CABE2 !important",
  },
});

const FileConfirmationDialog = (props: any) => {
  const { classes } = props;
  return (
    <div>
      <Dialog open={props.open} onClose={props.close}>
        <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
        <DialogContent>
          <div id="alert-dialog-description">
            <Typography variant="body1">
              {" "}
              Are you sure, you want to upload following File(s):
            </Typography>
            <div style={{ paddingTop: "10px" }}>
              {props.content.map((data: any, index: any) => {
                return (
                  <Typography variant="body1" key={index}>
                    {data.name}
                  </Typography>
                );
              })}
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={props.close}
            color="primary"
            className={classes.buttonColor}
          >
            CANCEL
          </Button>
          <Button
            onClick={props.ok}
            color="primary"
            autoFocus={true}
            className={classes.buttonColor}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withStyles(styles)(FileConfirmationDialog);
